"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var short_uuid_1 = __importDefault(require("short-uuid"));
var helpers_1 = require("./helpers");
var rpc_1 = require("./rpc");
var types_1 = require("./types");
var connections = {};
function isValidTarget(iframe, event) {
    var childURL = iframe.getAttribute("src");
    var childOrigin = helpers_1.getOriginFromURL(childURL);
    var hasProperOrigin = event.origin === childOrigin;
    var hasProperSource = event.source === iframe.contentWindow;
    return hasProperOrigin && hasProperSource;
}
/**
 * Perform a handshake with the target iframe, when the handshake is confirmed
 * resolve the connection object containing RPCs and properties
 *
 * @param iframe
 * @param schema
 * @param options
 * @returns Promise
 */
function connect(guest, schema, options) {
    if (schema === void 0) { schema = {}; }
    if (!guest)
        throw new Error("a target is required");
    // this check should be improved
    var guestIsWorker = guest.onerror !== undefined &&
        guest.onmessage !== undefined;
    var listeners = guestIsWorker ? guest : window;
    return new Promise(function (resolve, reject) {
        var connectionID = short_uuid_1.default.generate();
        // on handshake request
        function handleHandshake(event) {
            if (!guestIsWorker && !isValidTarget(guest, event))
                return;
            if (event.data.action !== types_1.actions.HANDSHAKE_REQUEST)
                return;
            // register local methods
            var localMethods = helpers_1.extractMethods(schema);
            var unregisterLocal = rpc_1.registerLocalMethods(schema, localMethods, connectionID, guestIsWorker ? guest : undefined);
            // register remote methods
            var _a = rpc_1.registerRemoteMethods(event.data.schema, event.data.methods, connectionID, event, guestIsWorker ? guest : undefined), remote = _a.remote, unregisterRemote = _a.unregisterRemote;
            var payload = {
                action: types_1.actions.HANDSHAKE_REPLY,
                connectionID: connectionID,
                methods: localMethods,
                schema: JSON.parse(JSON.stringify(schema)),
            };
            // confirm the connection
            if (guestIsWorker)
                guest.postMessage(payload);
            else
                event.source.postMessage(payload, event.origin);
            // close the connection and all listeners when called
            var close = function () {
                listeners.removeEventListener(types_1.events.MESSAGE, handleHandshake);
                unregisterRemote();
                unregisterLocal();
            };
            // resolve connection object
            var connection = { remote: remote, close: close };
            connections[connectionID] = connection;
            return resolve(connection);
        }
        // subscribe to HANDSHAKE MESSAGES
        listeners.addEventListener(types_1.events.MESSAGE, handleHandshake);
    });
}
exports.default = ({
    connect: connect,
});
//# sourceMappingURL=host.js.map